import {
  FieldState,
  valYoutubeChannelBaseURL,
} from "../../../utils/ValidationFunctions";

export const validFieldState = (
  pageType: "create" | "edit", // 作成ページ or 編集ページ
  requiredList: Array<string>,
  fieldState?: FieldState
) => {
  let error = false;
  switch (pageType) {
    case "create":
      // 必須項目があり、未入力の場合
      if (requiredList.length > 0 && fieldState === undefined) {
        error = true;
        break;
      }

      // 必須項目が入力されているか確認
      for (const key in requiredList) {
        if (fieldState?.[requiredList[key]] === undefined) {
          error = true;
          break;
        }
      }
      if (error) {
        break;
      }

      // 入力値に問題があるかを確認
      for (const key in fieldState) {
        if (fieldState[key][1] === false) {
          error = true;
          break;
        }
      }
      break;

    case "edit":
      // 変更があるかを確認
      if (fieldState === undefined) {
        break;
      }

      // 入力値に問題があるかを確認
      for (const key in fieldState) {
        if (fieldState[key][1] === false) {
          error = true;
          break;
        }
      }
      break;
    default:
      break;
  }

  return error ? false : true;
};

export const fieldStateToUpdateArgs = (
  update_args: { [key: string]: string | File },
  fieldState?: FieldState
) => {
  if (fieldState === undefined) {
    return;
  }

  for (const key in fieldState) {
    const value = fieldState[key][0];
    switch (key) {
      case "sonic_youtube":
        if (typeof value === "string" && !valYoutubeChannelBaseURL(value)) {
          update_args[key] = value;
        } else {
          update_args[key] = "";
        }
        break;
      default:
        if (fieldState[key][1] !== false) {
          update_args[key] = value;
        }
        break;
    }
  }
  return;
};
